import { render, staticRenderFns } from "./CustomerDetailAccountStatement.vue?vue&type=template&id=55e42eda&scoped=true&"
import script from "./CustomerDetailAccountStatement.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailAccountStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e42eda",
  null
  
)

export default component.exports